export interface IApplicationState {
    spinButtonActive: boolean;
    stopButtonActive: boolean;
    spinButtonClicked: boolean;
    betIncreaseButtonClicked: boolean;
    betDecreaseButtonClicked: boolean;
    buttonClickedSound: boolean;
    allButtonEnable: boolean;
    exceptBtnList: Array<string>;

}

const initialState: IApplicationState = {
    spinButtonActive: false,
    stopButtonActive: false,
    spinButtonClicked: false,
    betIncreaseButtonClicked: false,
    betDecreaseButtonClicked: false,
    allButtonEnable: true,
    buttonClickedSound: false,
    exceptBtnList: []
};

export enum actionTypes {
    BUTTON_CLICKED = '@@application/BUTTON_CLICKED',
    SET_All_BUTTON_ENABLE = '@@application/SET_All_BUTTON_ENABLE',
    SET_All_BUTTON_DISABLE = '@@application/SET_All_BUTTON_DISABLE',
    SET_APPLICATION_STOP_ACTIVE = '@@application/SET_APPLICATION_STOP_ACTIVE',
    GET_APPLICATION_SPIN_CLICK = '@@application/GET_APPLICATION_SPIN_CLICK',
    SET_APPLICATION_SPIN_CLICK = '@@application/SET_APPLICATION_SPIN_CLICK',
    SET_APPLICATION_BET_INCREASE_CLICK = '@@application/SET_APPLICATION_BET_INCREASE_CLICK',
    GET_APPLICATION_BET_INCREASE_CLICK = '@@application/GET_APPLICATION_BET_INCREASE_CLICK',
    SET_APPLICATION_BET_DECREASE_CLICK = '@@application/SET_APPLICATION_BET_DECREASE_CLICK',
    GET_APPLICATION_BET_DECREASE_CLICK = '@@application/GET_APPLICATION_BET_DECREASE_CLICK'
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { exceptBtnList } = state
    const { isClicked, exceptBtnListFromAction, resetOldList, stopActive } = action;
    switch (action.type) {
        case actionTypes.GET_APPLICATION_SPIN_CLICK:
            return { ...state };
        case actionTypes.SET_APPLICATION_SPIN_CLICK:
            return {
                ...state, spinButtonClicked: isClicked,
            };
        case actionTypes.SET_APPLICATION_STOP_ACTIVE:
            return {
                ...state, stopButtonActive: stopActive,
            };

        case actionTypes.BUTTON_CLICKED:
            return {
                ...state, buttonClickedSound: isClicked,
            };
        case actionTypes.SET_All_BUTTON_ENABLE:
            return {
                ...state, allButtonEnable: true, exceptBtnList: exceptBtnListFromAction,
            };
        case actionTypes.SET_All_BUTTON_DISABLE:
            return {
                ...state, allButtonEnable: false, exceptBtnList: exceptBtnListFromAction,
            };

        case actionTypes.GET_APPLICATION_BET_INCREASE_CLICK:
            return { ...state };
        case actionTypes.SET_APPLICATION_BET_INCREASE_CLICK:
            return {
                ...state, betIncreaseButtonClicked: isClicked,
            };

        case actionTypes.GET_APPLICATION_BET_DECREASE_CLICK:
            return { ...state };
        case actionTypes.SET_APPLICATION_BET_DECREASE_CLICK:
            return {
                ...state, betDecreaseButtonClicked: isClicked,
            };

        default:
            return state;
    }
}

export const actions = {
    setApplicationSpinButtonClicked: (isClicked: boolean): any => ({
        type: actionTypes.SET_APPLICATION_SPIN_CLICK,
        isClicked
    }),
    setApplicationButtonClicked: (isClicked: boolean): any => ({
        type: actionTypes.BUTTON_CLICKED,
        isClicked
    }),
    setStopActive: (stopActive: boolean): any => ({
        type: actionTypes.SET_APPLICATION_STOP_ACTIVE,
        stopActive
    }),
    getApplicationSpinButtonClicked: (): any => ({ type: actionTypes.GET_APPLICATION_SPIN_CLICK }),

    setApplicationIncreaseButtonClicked: (isClicked: boolean): any => ({
        type: actionTypes.SET_APPLICATION_BET_INCREASE_CLICK,
        isClicked
    }),
    getApplicationIncreaseButtonClicked: (): any => ({ type: actionTypes.GET_APPLICATION_BET_INCREASE_CLICK }),

    setApplicationDecreaseButtonClicked: (isClicked: boolean): any => ({
        type: actionTypes.SET_APPLICATION_BET_DECREASE_CLICK,
        isClicked
    }),
    getApplicationDecreaseButtonClicked: (): any => ({ type: actionTypes.GET_APPLICATION_BET_DECREASE_CLICK }),
    setAllButtonEnable: (exceptBtnListFromAction: Array<string> = [], resetOldList: boolean = false): any => ({
        type: actionTypes.SET_All_BUTTON_ENABLE, exceptBtnListFromAction, resetOldList
    }),
    setAllButtonDisable: (exceptBtnListFromAction: Array<string> = [], resetOldList: boolean = false): any => ({
        type: actionTypes.SET_All_BUTTON_DISABLE, exceptBtnListFromAction, resetOldList
    }),

};